var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayoutSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1976d2",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,76 H72 V84 H24 Z M96,76 H232 V84 H96 Z M84,68 A12,12,0,1,0,84,92 A12,12,0,1,0,84,68 Z M24,124 H160 V132 H24 Z M184,124 H232 V132 H184 Z M172,116 A12,12,0,1,0,172,140 A12,12,0,1,0,172,116 Z M24,172 H96 V180 H24 Z M120,172 H232 V180 H120 Z M108,164 A12,12,0,1,0,108,188 A12,12,0,1,0,108,164 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutSetting);
export default __webpack_public_path__ + "static/media/payout_setting.eb0050226d6684f7827639a79ddba0e0.svg";
export { ForwardRef as ReactComponent };